var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.527,
    height: 15.518,
    viewBox: "0 0 15.527 15.518",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home_3_",
    "data-name": "home (3)",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55069",
    "data-name": "Path 55069",
    d: "M193.941,319.841A1.941,1.941,0,0,0,192,321.782v3.882h3.882v-3.882A1.941,1.941,0,0,0,193.941,319.841Z",
    transform: "translate(-186.177 -310.146)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_47927",
    "data-name": "Group 47927"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55070",
    "data-name": "Path 55070",
    d: "M11,11.8v3.882h2.588a1.941,1.941,0,0,0,1.941-1.941v-5.9a1.294,1.294,0,0,0-.364-.9L9.665.991A2.588,2.588,0,0,0,6.008.847q-.075.069-.144.144L.376,6.933A1.294,1.294,0,0,0,0,7.845v5.891a1.941,1.941,0,0,0,1.941,1.941H4.529V11.8a3.235,3.235,0,1,1,6.47,0Z",
    transform: "translate(0 -0.16)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55071",
    "data-name": "Path 55071",
    d: "M193.941,319.841A1.941,1.941,0,0,0,192,321.782v3.882h3.882v-3.882A1.941,1.941,0,0,0,193.941,319.841Z",
    transform: "translate(-186.177 -310.146)",
    fill: "#387f75"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarHome);
export default __webpack_public_path__ + "static/media/sidebar-home.13137723454b7a272ebc62ccb901a9ab.svg";
export { ForwardRef as ReactComponent };